import { type } from '../../constants/QBActionsConst'

export const checkCreateReportPermission = userInfo => {
    if (userInfo.tier_id >= 1 && userInfo.tier_id <= 3)
        return true
    const { actions } = userInfo
    if (!actions) return false

    return actions.indexOf(type.REPORT_CREATE) > -1
}

export const checkViewReportPermission = userInfo => {
    if (userInfo.tier_id >= 1 && userInfo.tier_id <= 3)
        return true
    const { actions } = userInfo
    if (!actions) return false

    return actions.indexOf(type.REPORT_VIEW) > -1
}

export const checkEditReportPermission = userInfo => {
    if (userInfo.tier_id >= 1 && userInfo.tier_id <= 3)
        return true
    const { actions } = userInfo
    if (!actions) return false

    return actions.indexOf(type.REPORT_EDIT) > -1
}

export const checkDeleteReportPermission = userInfo => {
    if (userInfo.tier_id >= 1 && userInfo.tier_id <= 3)
        return true
    const { actions } = userInfo
    if (!actions) return false

    return actions.indexOf(type.REPORT_DELETE) > -1
}

export default {
    checkCreateReportPermission,
    checkViewReportPermission,
    checkEditReportPermission,
    checkDeleteReportPermission
}